/* NAGAIA Cart v16
   v16 (2026-08-10): trust block rebuilt to the approved mockup.
     - Row order is now EVIDENCE FIRST: rating, then the promise, then support.
       A shopper at the button is doing risk assessment; social proof answers
       "has anyone else done this" before we answer "what if it goes wrong".
     - The rating row carries a star glyph. 4.7 alone read as a number with no
       provenance; stars plus a review count read as a summary of other people.
     - The italic eyebrow is no longer rendered. It answered only "I don't know
       how" and cost a line at the densest point of the page. cardEye is still
       read from the dataset so the setting can be revived without new plumbing.
     - Rewards is dropped from this block. It is a promotion, not a trust
       signal; sitting inside the confidence list it weakened both. Restore by
       pushing a row with ICO.coin here — nothing else needs changing.
     - The payment/guest row is MOVED INSIDE the card, badges above the guest
       line, so the block reads as one object instead of two loose fragments.
     - The block IS framed now. assets/nagaia-cart.css v15 reserved the framed
       treatment for .nag-ms alone; that call is reversed at its source there,
       with the reasoning. Do not re-flatten this without reading it.

   v14 (2026-07-27): the guest row + payment badges render into #nag-pay-slot,
   which main-cart.liquid places directly after the checkout button. The old
   anchor was `.additional-checkout-buttons` + afterend, and the express
   wallets have since moved ABOVE the Check out button — that anchor would have
   dropped the guest line between the wallets and the button.
   v13: the processing line renders into #nag-top-slot when main-cart.liquid
   provides it. That slot sits ABOVE the two-column grid, so both columns start
   on the same horizontal line.
   v12: guest/security line is two labelled spans with a separator between them
   so a narrow column can stack them instead of leaving a dangling middot.
   Clear cart renders into #nag-clear-slot so it shares the footer row with
   Continue shopping. Styling for both lives in main-cart.liquid.
   v11: SKU badge block removed. Free-shipping fallback threshold 59 -> 55.
*/
(function () {
  'use strict';
  var el = document.getElementById('nagaia-cart-data');
  if (!el || window.__nagaiaCartV14) return;
  window.__nagaiaCartV14 = true;

  var cfg = {
    threshold:    parseFloat(el.dataset.threshold) || 55,
    cartTotal:    parseFloat(el.dataset.cartTotal) || 0,
    itemCount:    parseInt(el.dataset.itemCount, 10) || 0,
    returning:    el.dataset.returning === 'true',
    pointsPer:    parseFloat(el.dataset.pointsPer) || 5,
    rewardsName:  el.dataset.rewardsName || 'NAGAIA Rewards',
    processing:   el.dataset.processing || '',
    cardEye:      el.dataset.cardEye || '',
    guarTitle:    el.dataset.guarTitle || '',
    guarSub:      el.dataset.guarSub || '',
    supTitle:     el.dataset.supTitle || '',
    supSub:       el.dataset.supSub || '',
    rateTitle:    el.dataset.rateTitle || '',
    rateSub:      el.dataset.rateSub || '',
    securityText: el.dataset.securityText || '',
    guestText:    el.dataset.guestText || ''
  };
  if (cfg.itemCount < 1) return;

  function svg(paths, size, color) {
    var p = Array.isArray(paths) ? paths : [paths];
    return '<svg width="'+(size||19)+'" height="'+(size||19)+'" viewBox="0 0 24 24" fill="none" stroke="'+(color||'currentColor')+'" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">'
      + p.map(function(d){return '<path d="'+d+'"/>';}).join('') + '</svg>';
  }

  var ICO = {
    truck:       ['M1 3h15v13H1z','M16 8h4l3 3v5h-7V8z','M5.5 21.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z','M18.5 21.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z'],
    shieldCheck: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z','M9 12l2 2 4-4'],
    mail:        ['M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z','M2.5 6.2l9.5 6.6 9.5-6.6'],
    star:        ['M12 3l2.7 5.5 6 .9-4.3 4.2 1 6-5.4-2.8L6.6 19.8l1-6L3.3 9.4l6-.9L12 3z'],
    coin:        ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z','M12 7v10','M14.2 9.4a2.3 2.3 0 0 0-2.2-1.3h-.4a1.85 1.85 0 0 0 0 3.7h.8a1.85 1.85 0 0 1 0 3.7H12a2.3 2.3 0 0 1-2.2-1.3'],
    lock:        ['M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z','M7 11V7a5 5 0 0 1 10 0v4'],
    trash:       ['M3 6h18','M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2','M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6','M10 11v6','M14 11v6']
  };

  function find() {
    for (var i=0;i<arguments.length;i++){var n=document.querySelector(arguments[i]);if(n)return n;}
    return null;
  }

  /* Clear cart modal */
  function showClearModal() {
    var old = document.getElementById('nag-clear-modal');
    if (old) old.parentNode.removeChild(old);

    var bg    = document.createElement('div'); bg.id='nag-clear-modal'; bg.className='nag-clear-modal-bg';
    var box   = document.createElement('div'); box.className='nag-clear-modal__box';
    var ttl   = document.createElement('div'); ttl.className='nag-clear-modal__title'; ttl.textContent='Clear your cart?';
    var sub   = document.createElement('div'); sub.className='nag-clear-modal__sub';   sub.textContent='All items will be removed. This cannot be undone.';
    var btns  = document.createElement('div'); btns.className='nag-clear-modal__btns';
    var keep  = document.createElement('button'); keep.className='nag-clear-modal__cancel';  keep.type='button'; keep.textContent='Keep shopping';
    var clear = document.createElement('button'); clear.className='nag-clear-modal__confirm'; clear.type='button'; clear.textContent='Clear cart';

    btns.appendChild(keep); btns.appendChild(clear);
    box.appendChild(ttl); box.appendChild(sub); box.appendChild(btns);
    bg.appendChild(box); document.body.appendChild(bg);

    keep.addEventListener('click',  function(){ document.body.removeChild(bg); });
    bg.addEventListener('click',    function(e){ if(e.target===bg) document.body.removeChild(bg); });
    clear.addEventListener('click', function(){
      clear.textContent='Clearing\u2026'; clear.disabled=true;
      fetch('/cart/clear.js',{method:'POST'})
        .then(function(){ window.location.reload(); })
        .catch(function(){ window.location.href='/cart'; });
    });
  }

  /* Clear cart: footer row, opposite Continue shopping */
  (function(){
    if (document.querySelector('.nag-clear-wrap')) return;

    var wrap = document.createElement('div'); wrap.className='nag-clear-wrap';
    var btn  = document.createElement('button'); btn.className='nag-clear-cart__btn'; btn.type='button';
    btn.innerHTML = svg(ICO.trash,13,'#9B958E')+'<span>Clear cart</span>';
    btn.addEventListener('click', showClearModal);
    wrap.appendChild(btn);

    var slot = document.getElementById('nag-clear-slot');
    if (slot) { slot.appendChild(wrap); return; }
    var items = document.querySelector('.cart-items');
    if (items && items.parentNode) { items.parentNode.insertBefore(wrap, items.nextSibling); return; }
    var anchor = find('.cart-subtotal-and-discounts');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  })();

  /* Processing line: above the grid when a slot exists. */
  (function(){
    if (!cfg.processing) return;
    var wrap = document.createElement('div'); wrap.className='nag-proc';
    wrap.innerHTML = svg(ICO.truck,16,'#6B6660')+'<span>'+cfg.processing+'</span>';

    var slot = document.getElementById('nag-top-slot');
    if (slot) { slot.appendChild(wrap); return; }
    var items = document.querySelector('.cart-items');
    if (items && items.parentNode) items.parentNode.insertBefore(wrap, items);
  })();

  /* Payment badges + guest line. Built here, MOVED into the trust card below.
     Badges first, guest line under them (mockup order). If securityText is
     blank the lock icon moves onto the guest line, so that sentence is never
     left without a mark beside it. */
  (function(){
    var pe=document.getElementById('nagaia-pay-icons');
    var icons=pe?pe.innerHTML.trim():'';
    if(!icons&&!cfg.securityText&&!cfg.guestText) return;
    var html='<div class="nag-pay">';
    if(icons) html+='<div class="nag-pay__methods">'+icons+'</div>';
    if(cfg.securityText||cfg.guestText){
      html+='<div class="nag-pay__sec">';
      if(cfg.securityText) html+='<span class="nag-pay__bit">'+svg(ICO.lock,14,'#5A554F')+'<span>'+cfg.securityText+'</span></span>';
      if(cfg.guestText) html+='<span class="nag-pay__bit">'+(cfg.securityText?'':svg(ICO.lock,14,'#5A554F'))+'<span>'+cfg.guestText+'</span></span>';
      html+='</div>';
    }
    html+='</div>';

    var slot=document.getElementById('nag-pay-slot');
    if(slot){ slot.innerHTML=html; return; }
    var b=find('.cart-checkout-button','button[name="checkout"]','.cart__checkout-button');
    if(b) b.insertAdjacentHTML('afterend',html);
  })();

  /* Trust card. Evidence first, then the promise, then the human. */
  (function(){
    var rows=[
      {ic:ICO.star,       t:cfg.rateTitle,d:cfg.rateSub, stars:true},
      {ic:ICO.shieldCheck,t:cfg.guarTitle,d:cfg.guarSub},
      {ic:ICO.mail,       t:cfg.supTitle, d:cfg.supSub}
    ].filter(function(r){return r.t;});
    if(!rows.length) return;

    var conf='<div class="nag-conf"><div class="nag-conf__list">';
    rows.forEach(function(r){
      conf+='<div class="nag-conf__item"><span class="nag-conf__ic">'+svg(r.ic,19,'#C92072')+'</span>'
        +'<div><div class="nag-conf__t">'
        +(r.stars?'<span class="nag-conf__stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>':'')
        +'<span>'+r.t+'</span></div>'
        +(r.d?'<div class="nag-conf__d">'+r.d+'</div>':'')+'</div></div>';
    });
    conf+='</div></div>';

    var pay=document.querySelector('.nag-pay');
    if(pay) pay.insertAdjacentHTML('afterend',conf);
    else{
      var cb=find('.cart-checkout-button','button[name="checkout"]','.cart__checkout-button');
      if(cb) cb.insertAdjacentHTML('afterend',conf);
      else{var it=document.querySelector('.cart-items');if(it)it.insertAdjacentHTML('afterend',conf);}
    }

    /* Fold the badges + guest line into the card so it reads as one object. */
    var card=document.querySelector('.nag-conf');
    if(card&&pay) card.appendChild(pay);
  })();

  /* Mobile sticky bar. NOTE: assets/nagaia-cart.css keeps .nag-sticky at
     display:none on purpose — this DOM has never been visible to a customer. */
  (function(){
    var total=cfg.cartTotal.toFixed(2);
    var label=cfg.itemCount===1?'1 item':cfg.itemCount+' items';
    var trust=[cfg.guarTitle,cfg.securityText].filter(Boolean).join(' \u00B7 ');
    var sticky=document.createElement('div'); sticky.className='nag-sticky';
    var row=document.createElement('div');    row.className='nag-sticky__row';
    var info=document.createElement('div');   info.className='nag-sticky__info';
    info.innerHTML='<div class="nag-sticky__total">$'+total+'</div><div class="nag-sticky__count">'+label+'</div>';
    var sb=document.createElement('button');  sb.className='nag-sticky__btn'; sb.type='button'; sb.textContent='Checkout';
    sb.addEventListener('click',function(){var b=find('.cart-checkout-button','button[name="checkout"]','.cart__checkout-button');if(b)b.click();});
    row.appendChild(info); row.appendChild(sb); sticky.appendChild(row);
    if(trust){var te=document.createElement('div');te.className='nag-sticky__trust';te.textContent=trust;sticky.appendChild(te);}
    document.body.appendChild(sticky);
  })();

})();
